export const defaultStyle = {
    wrapper: "relative",
}
